import { gql } from '@apollo/client';

// RITA-1526 — GraphQL-Dokumente der Vertragsarten-Seite mit Logo.
//
// Die App-Start-Abfrage der Vertragsarten (Apollo/queries/getContractTypes, DataProvider) bleibt
// bewusst ohne logo_data_url: das Feld wird im Backend nur geladen, wenn eine Abfrage es auswählt,
// und ein Logo kann bis zu 1 MB groß sein. Nur die Einstellungsseite fragt es hier mit ab.
// Die Datei geht als Multipart-Upload (Scalar Upload, apollo-upload-client) zum Backend.

const CONTRACT_TYPE_WITH_LOGO_FIELDS = gql`
  fragment ContractTypeWithLogoFields on ContractType {
    id
    title
    is_default
    logo_data_url
  }
`;

export const GET_CONTRACT_TYPES_WITH_LOGO = gql`
  query getContractTypesWithLogo {
    getAllContractTypes {
      ...ContractTypeWithLogoFields
    }
  }
  ${CONTRACT_TYPE_WITH_LOGO_FIELDS}
`;

export const SET_CONTRACT_TYPE_LOGO = gql`
  mutation setContractTypeLogo($id: Int!, $logo: Upload!) {
    setContractTypeLogo(id: $id, logo: $logo) {
      ...ContractTypeWithLogoFields
    }
  }
  ${CONTRACT_TYPE_WITH_LOGO_FIELDS}
`;

export const DELETE_CONTRACT_TYPE_LOGO = gql`
  mutation deleteContractTypeLogo($id: Int!) {
    deleteContractTypeLogo(id: $id) {
      ...ContractTypeWithLogoFields
    }
  }
  ${CONTRACT_TYPE_WITH_LOGO_FIELDS}
`;
